import { render, staticRenderFns } from "./GastosFormCategoria.vue?vue&type=template&id=129cd745&scoped=true&"
import script from "./GastosFormCategoria.vue?vue&type=script&lang=js&"
export * from "./GastosFormCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129cd745",
  null
  
)

export default component.exports